import api from './axiosInstance';

// List of roles
export const getPagedRoles = {
  getRoles: async (
    page,
    pageSize,
    search = '',
    sortKey = null,
    sortDirection = null
  ) => {
    try {
      const params = {
        page,
        pageSize,
        search: search || '',
      };

      if (sortKey) params.sortBy = sortKey;
      if (sortDirection !== null) params.desc = sortDirection === 'desc';

      const response = await api.get(`/RoleSaas/paged`, {
        headers: {
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo obtener el listado de roles.';
      throw error;
    }
  },
};

// Tree to create a role
export const getPermissionGroupsTree = {
  getTree: async () => {
    try {
      const response = await api.get(`/RoleSaas/permission-groups-tree`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudieron obtener los permisos disponibles.';
      throw error;
    }
  },
};

// To create a rol
export const createRole = {
  postCreate: async ({ name, description, permissionIds }) => {
    try {
      const response = await api.post(
        '/RoleSaas',
        {
          name,
          description: description || null,
          permissionIds: permissionIds || [],
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo crear el rol.';
      throw error;
    }
  },
};

// Details of an existing role
export const getPermissionDetail = {
  getDetail: async (roleId) => {
    try {
      const response = await api.get(`/RoleSaas/${roleId}/detail`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudieron obtener los detalles por role.';
      throw error;
    }
  },
};

// Tree of an existing role
export const getPermissionGroupsTreeById = {
  getTree: async (roleId) => {
    try {
      const response = await api.get(
        `/RoleSaas/${roleId}/permission-groups-tree`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudieron obtener los permisos por role.';
      throw error;
    }
  },
};

// To edit a rol description
export const editRoleDescription = {
  putEditDescription: async ({ roleId, name, description, isEnabled }) => {
    try {
      const response = await api.put(
        `/RoleSaas/${roleId}`,
        {
          name,
          description,
          isEnabled,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo editar la descripción del rol.';
      throw error;
    }
  },
};

// To edit a rol tree
export const editRolePermissions = {
  putEditPermissions: async ({ roleId, permissionIds }) => {
    try {
      const response = await api.put(
        `/RoleSaas/${roleId}/permissions`,
        {
          permissionIds,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudieron editar los permisos del rol.';
      throw error;
    }
  },
};

// Delete role
export const deleteRole = {
  deleteById: async (roleId) => {
    try {
      const response = await api.delete(`/RoleSaas/${roleId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo eliminar el rol.';
      throw error;
    }
  },
};

// To know the permissions for a usar after login
export const getUserPermissions = {
  getPermissions: async () => {
    try {
      const response = await api.get('/RoleSaas/permissions', {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data || [];
    } catch (error) {
      error.customMessage = 'No se pudieron obtener los permisos del usuario.';
      throw error;
    }
  },
};
